import { formatText, type Label } from "../texts";
import { attemptText, eventText } from "../orgs/organizations";

// Reglas de Mi cuenta (R7) sin React: qué pasó en la actividad, su detalle y las pestañas de Seguridad. Se prueban en
// account.test.tsx.

export type SecurityTab = "summary" | "password" | "mfa" | "sessions" | "activity";

export const securityTabs: { key: SecurityTab; labelKey: string; href: string }[] = [
  { key: "summary", labelKey: "ADM_ACC_TAB_SUMMARY", href: "/Account/Security" },
  { key: "password", labelKey: "ADM_ACC_TAB_PASSWORD", href: "/Account/Security/Password" },
  { key: "mfa", labelKey: "ADM_ACC_TAB_MFA", href: "/Account/Security/Mfa" },
  { key: "sessions", labelKey: "ADM_ACC_TAB_SESSIONS", href: "/Account/Security/Sessions" },
  { key: "activity", labelKey: "ADM_ACC_TAB_ACTIVITY", href: "/Account/Security/Activity" },
];

export type ActivityRow = {
  kind: "SIGN_IN" | "SECURITY";
  key: string;
  occurredAt: string;
  success: boolean | null;
  failureReason: string | null;
  ip: string | null;
  browser: string | null;
  os: string | null;
  action: string | null;
  actorContext: string | null;
  actorName: string | null;
};

/** Lo que se ve de un navegador o sistema: nunca «UNKNOWN» (E40). */
const known = (value: string | null) => (value && value.toUpperCase() !== "UNKNOWN" ? value : null);

/**
 * Qué pasó, en palabras y en segunda persona cuando es tu cuenta: «Ingreso correcto», «Contraseña incorrecta» (marcado),
 * «Cambiaste tu contraseña». Un evento sin frase propia usa la del historial de una persona.
 */
export function activityText(L: Label, row: ActivityRow): { text: string; failed: boolean } {
  if (row.kind === "SIGN_IN") {
    if (row.success) return { text: L("ADM_ACC_SIGN_IN_OK"), failed: false };
    return { text: attemptText(L, false, row.failureReason).text, failed: true };
  }
  const own = L(`ADM_ACC_EVT_${row.action ?? ""}`);
  return { text: own.startsWith("⟦") ? eventText(L, row.action ?? "") : own, failed: false };
}

/** Detalle: el navegador, el sistema y la IP de un ingreso; de un evento, desde dónde se hizo. */
export function activityDetail(L: Label, row: ActivityRow): string {
  if (row.kind === "SIGN_IN") return [known(row.browser), known(row.os), row.ip].filter(Boolean).join(" · ") || "—";
  switch (row.actorContext) {
    case "SYSTEM":
      return L("ADM_PPL_ACTOR_SYSTEM");
    case "PLATFORM_ADMIN":
      return L("ADM_ACC_FROM_ADMIN");
    case "COMPANY_PORTAL":
      return L("ADM_ACC_FROM_PORTAL");
    default:
      return row.actorName ?? "—";
  }
}

/** «Hubo 1 intento fallido…» / «Hubo 3 intentos fallidos…» (E18). */
export const failedNotice = (L: Label, count: number) =>
  formatText(L(count === 1 ? "ADM_ACC_FAILED_ONE" : "ADM_ACC_FAILED"), count);

/** Filtro de la actividad en la dirección (Todo por defecto). */
export const normalizeActivityFilter = (value: string | null): "all" | "signins" | "security" =>
  value === "signins" || value === "security" ? value : "all";
